<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Research</b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Academinc Indirect Cost</b-breadcrumb-item>
            <b-breadcrumb-item to="/Research/AcademicIndirectCost/PayPeriods">Pay Periods</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ payPeriodStartDate | moment('MMMM YYYY') }}</b-breadcrumb-item>
            <b-breadcrumb-item active>{{ adLoc }}</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="card-header">
              <ul class="card-header-tabs nav nav-tabs">
                  <li class="nav-item">
                      <a @click="currentTabComponent='TheResponsiblePersonList'" :class="currentTabComponent === 'TheResponsiblePersonList' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">PIs</a>
                  </li>
                  <li class="nav-item">
                      <a @click="currentTabComponent='ThePayeeList'" :class="currentTabComponent === 'ThePayeeList' ? 'active' : null" class="nav-link"
                          data-toggle="tab"
                          href="#">Accounts</a>
                  </li>
              </ul>
            </div>
            <div class="card-body">
              <fieldset class="border p-3 mb-2" style="height: 100%;">
                  <legend class="w-auto h5"></legend>
                  <div class="row">
                    <div class="col"><b>Fiscal Year:</b> {{ fiscalYear }}</div>
                    <div class="col"><b>AdLoc:</b> {{ adLoc }}</div>
                  </div>
                  <div class="row">
                    <div class="col"><b>Department:</b> {{ departmentName }}</div>
                    <div class="col"><b>Period:</b> {{ payPeriodStartDate | moment('MMMM YYYY') }}</div>
                  </div>
              </fieldset>
              <div id="tab-container">
                <keep-alive>
                  <component :is="currentTabComponent" :adLoc="adLoc" 
                                                       :fiscalYear="fiscalYear" 
                                                       :payPeriodStartDate="payPeriodStartDate" 
                                                       :canEdit="canEdit" 
                                                       :departmentName="departmentName" />
                </keep-alive>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import TheResponsiblePersonList from "@/components/academicIndirectCost/TheResponsiblePersonList.vue";
import ThePayeeList from "@/components/academicIndirectCost/ThePayeeList.vue";

export default {
    components: {
      TheResponsiblePersonList,
      ThePayeeList
    },
    props: {
      adLoc: {
        required: true,
        type: String
      },
      fiscalYear: {
        required: true,
        type: Number
      },
      payPeriodStartDate: {
        required: true,
        type: Date
      },
      canEdit: {
        required: true,
        type: Boolean
      },
      departmentName: {
        required: true,
        type: String
      },
      payPeriodStartDateDisplay: {
        required: true,
        type: String
      }
    },
    data() {
        return {
            currentTabComponent: "TheResponsiblePersonList"
        }
    }
}
</script>
